
import { mapActions, mapGetters } from 'vuex';
import Filter from '@/interfaces/filter.interface';
import tracking from '@/functions/tracking';
import mTag from '@/components/molecules/form/Tag.vue';
import { EventBus } from '@/functions/eventBus';

interface Data {
    isDesktop: boolean;
}

export default {
    components: {
        mTag,
    },

    data(): Data {
        return {
            isDesktop: EventBus.isDesktop,
        };
    },

    computed: {
        ...mapGetters({
            filters: 'search/filters',
            order: 'search/order',
        }),
        /**
         * Check if the store has any filters.
         *
         * @return {boolean}
         */
        hasFilters(): boolean {
            return this.filters.length > 0;
        },
    },

    mounted(): void {
        EventBus.$on('app.resize', () => {
            this.isDesktop = EventBus.isDesktop;
        });
    },

    beforeUnmount(): void {
        EventBus.$off('app.resize');
    },

    methods: {
        ...mapActions({
            toggleFilter: 'search/toggleFilter',
        }),

        switchFilter(payload: Filter): void {
            this.toggleFilter({
                key: payload.key,
                label: payload.label,
                shortName: payload.shortName,
                value: payload.value,
            });

            tracking.track(
                'trackFilter',
                'Filtersoegning',
                `${payload.label} - Sortering: ${this.order}`,
                '',
            );
        },
    },
};
